import { useMemo } from 'react';
import { useErxNotifications } from 'shared/features/erx';
import { ManageMedicationIcon, RxFilled } from 'shared/assets/icons';
import { WarningIcon } from '@springcare/sh-component-library';
export var useErxNavItem = function (pathname, enabled) {
    var data = useErxNotifications(enabled).data;
    var erxNavItem = useMemo(function () {
        var hasNotifications = data ? Object.values(data).some(function (v) { return v > 0; }) : false;
        return {
            icon: ManageMedicationIcon,
            activeIcon: RxFilled,
            title: 'eRx',
            url: '/erx',
            isActive: pathname.split('/').includes('erx'),
            isPinnedToBottom: false,
            badgeIcon: hasNotifications ? WarningIcon : undefined,
            badgeColor: 'negative.onSubtle',
        };
    }, [pathname, data]);
    return erxNavItem;
};
